import { homeCopy } from '../content/home'
import type { Lang } from '../i18n'
import PhoneMock from '../components/PhoneMock'
import StoreBadges from '../components/StoreBadges'
import styles from './HomePage.module.css'

/**
 * One page, three sections. #features and #about are what the header nav points at,
 * so the ids here and the links in Header.tsx have to stay in step.
 */
export default function HomePage({ lang }: { lang: Lang }) {
  const t = homeCopy[lang]

  return (
    <>
      <section id="home" className={`container ${styles.hero}`}>
        <div className={styles.heroText}>
          <span className={styles.eyebrow}>{t.heroEyebrow}</span>
          <h1 className={styles.title}>{t.heroTitle}</h1>
          <p className={styles.sub}>{t.heroSub}</p>

          <ul className={styles.leads}>
            {t.leads.map((lead) => (
              <li key={lead} className={styles.lead}>
                <span className={styles.bullet} />
                <span>{lead}</span>
              </li>
            ))}
          </ul>

          <StoreBadges copy={t} />
        </div>

        <PhoneMock copy={t} />
      </section>

      <section id="features" className={styles.features}>
        <div className={`container ${styles.featuresInner}`}>
          <div className={styles.sectionHead}>
            <h2 className={styles.sectionTitle}>{t.featTitle}</h2>
            <p className={styles.sectionLead}>{t.featIntro}</p>
          </div>

          <div className={styles.featureGrid}>
            {t.features.map((feature) => (
              <article key={feature.title} className={styles.feature}>
                <h3 className={styles.featureTitle}>{feature.title}</h3>
                <p className={styles.featureBody}>{feature.body}</p>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section id="about" className={`container ${styles.about}`}>
        <div className={styles.aboutHead}>
          <h2 className={styles.sectionTitle}>{t.aboutTitle}</h2>
          <p className={styles.sectionLead}>{t.aboutLead}</p>
        </div>

        <div className={styles.aboutList}>
          {t.aboutItems.map((item) => (
            <div key={item.title} className={styles.aboutItem}>
              <h3 className={styles.aboutItemTitle}>{item.title}</h3>
              <p className={styles.featureBody}>{item.body}</p>
            </div>
          ))}
        </div>
      </section>
    </>
  )
}
